export const UniError = (msg, color = 'red') => {
    let errorCn = document.getElementById('error-container');
    let errorMsg = document.getElementById('error');

    errorCn.style.display = 'flex';
    errorCn.style.color = color;
    
    errorMsg.innerHTML = msg;
    setTimeout(()=> {
        errorCn.classList.add('active');
    },10);
}

export const UniErrorHide = () => {
    let errorCn = document.getElementById('error-container');
    errorCn.classList.remove('active');
    let errorMsg = document.getElementById('error');
    errorMsg.innerHTML = '';
}


export const CpError = (msg, color) => {
    let errorCn = document.getElementById('cp-error');
    // let errorMsg = document.getElementById('error');
    let colors = ['green', 'red', 'yellow'];
    for (let i = 0; i < 3; i++) {
        errorCn.classList.remove(colors[i]);
    }
    errorCn.classList.add('active');
    errorCn.classList.add(colors[color]);
    errorCn.innerHTML = msg;
}

export const CpErrorHide = () => {
    let errorCn = document.getElementById('cp-error');
    errorCn.classList.remove('active');
}
